<template lang="pug">
tr
  td {{ deal.InternalName }}
    a(:href="editDealLink" target="_blank" rel="noopener noreferrer") Edit deal
  td {{ price }}
  td {{ availableOnline }}
</template>

<script>
export default {
  name: 'DealRow',
  props: {
    deal: Object,
    priceFormatter: {
      type: Intl.NumberFormat,
      required: true,
    },
  },
  computed: {
    availableOnline() {
      return this.deal.AvailableOnline ? 'Yes' : 'No'
    },
    editDealLink() {
      return `/deals/${this.deal.Key}/edit`
    },
    price() {
      const dealPrice = this.deal.Price.DisplayIncludingTax ? this.deal.Price.IncludingTax : this.deal.Price.ExcludingTax
      return this.priceFormatter.format(dealPrice)
    },
  },
}
</script>

<style lang="stylus" scoped>
a
  padding 0 .5em
  text-decoration underline

  &:hover
    text-decoration none
</style>
